import { PropType, computed, defineComponent } from "vue";
import { OrderJson } from "../../OrderForm";
import CodeForm from "../../components/CodeForm";
import ArticleLayout, { ArticleFigure } from "../../layouts/ArticleLayout";

export default defineComponent({
    components: {
        ArticleLayout,
        CodeForm,
    },

    template: `
        <ArticleLayout :figure="figure">
            <div class="StepVoucher">
                <div class="StepVoucher__form">
                    <h1>Skorzystaj teraz</h1>

                    <CodeForm
                        type="multi"
                        :code="null"

                        :editmode="true"

                        button_class="button button--master"
                        button_label="Aktywuj kod"
                        :cancel_visible="false"

                        @apply="$emit('apply', $event)"
                        @applyoptions="$emit('applyoptions', $event)"
                    />
                </div>
            </div>
        </ArticleLayout>
    `,

    emits: [
        'apply',
        'applyoptions',
    ],

    props: {
        options: { type: Object as PropType<OrderJson>, required: true },
    },

    setup(props, ctx) {
        const figure = computed(() => {
            const result: ArticleFigure = {
                image: '/files/articles/vouchers/top.jpg',
                title: 'Masz kod promocyjny?',
                hero: '/files/articles/vouchers/hero.png',
            };

            return result;
        });

        return {
            figure,
        };
    },
});
